import { useHandleClickOutside } from '@/hooks/useHandleClickOutside'
import { Box, Text } from '@chakra-ui/react'
import { createContext, useRef, useState } from 'react'
import { CustomEditableControls } from './CustomEditableControls'
import { TinySelect } from './TinySelect'

interface IEditableContext {
  isEditing: boolean,
  setIsEditing: (isEditing: boolean) => void
}

const defaultState: IEditableContext = {
  isEditing: false,
  setIsEditing: () => { }
}

export const EditableContext = createContext<IEditableContext>(defaultState)

type EditableTinySelectProps = {
  variants: {
    value: string,
    id: number
  }[],
  valueText?: string
  isDisabled?: boolean
  onSubmit: (value: string, id: number) => void
  isEditing?: boolean
  showControls?: boolean
  value: string
}

export const EditableTinySelect = ({ variants, value, valueText, onSubmit, isDisabled, isEditing: edditing = false, showControls = true }: EditableTinySelectProps) => {
  const [isEditing, setIsEditing] = useState(edditing)

  const ref = useRef(null)
  useHandleClickOutside(ref, () => {
    setIsEditing(false)
  })

  return (
    <EditableContext.Provider value={{
      isEditing: isEditing,
      setIsEditing: setIsEditing
    }}>
      <Box sx={{ display: 'flex', gap: 1 }}>
        {!isEditing &&
                    <Text sx={{ p: 0, fontSize: 'sm', textDecoration: 'underline', textDecorationStyle: 'dotted' }}>
                      {valueText
                        ? valueText
                        : variants?.find(x => x.id.toString() == value)?.value
                      }

                    </Text>
        }
        {isEditing && <>
          <TinySelect ref={ref}
            isDisabled={isDisabled}
            onChange={(e) => {
              const dataset = e.target.options[e.target.selectedIndex].dataset
              onSubmit(dataset.value!, parseInt(e.target.value))
              setIsEditing(false)
            }}
            value={value}
          >
            {variants.map((option) => {
              if (!option.value || !option.id) return null

              return (
                <option key={option.value} value={option.id.toString()} data-value={option.value}>
                  {option.value}
                </option>

              )
            })}
          </TinySelect>
        </>
        }

        {!isDisabled && showControls && <CustomEditableControls />}
      </Box>
    </EditableContext.Provider>
  )
}